









































































import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import DragDropFiles from "@/components/DragDropFiles";

export default defineComponent({
  name: "EditPostDropZone",
  components: { BaseInputFile, BaseButton, BaseIcon, DragDropFiles },
  props: {
    multiple: { type: Boolean },
    allowedFileTypes: { type: Array as () => string[], required: true },
    showDropZone: { type: Boolean, required: true },
    dragAndDropProhibited: { type: Boolean, default: false },
    nativeUploadingAvailable: { type: Boolean, default: true },
    useStereoFiles: { type: Boolean, default: false },
  },
  data() {
    return {
      isDrag: false,
    };
  },
  methods: {
    onDragHandler(v: boolean) {
      this.isDrag = v;
    },
  },
});
